import { IoMenu } from "react-icons/io5";
import { useSidebar } from "../../contexts/SidebarContext";
import HeaderInfo from "./HeaderInfo";
import { motion } from "framer-motion";
import logoAR from "/logos/logo-ar.png";
import logoEN from "/logos/logo-en.png";
import favicon from "/logos/favicon.png";
import { useTranslation } from "react-i18next";

function Logo() {
  const {  i18n } = useTranslation();
  const { handleToggleSidebar, isShowingIconsOnly } = useSidebar();

  const isArabic = i18n.language === "ar";
  const logoSrc = isArabic ? logoAR : logoEN;
  const maxWidthClass = isArabic ? "max-w-[105px]" : "max-w-[120px]";

  return (
    <div className="relative col-start-1 col-end-13 flex h-full items-center justify-center border-b border-gray-500 bg-sidebar py-1 text-skyblue md:col-end-1">
      <div className="relative">
        {isShowingIconsOnly ? (
          <motion.img
            key="icon-logo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.4 }}
            className="h-[2.4rem] w-[2.4rem] md:ps-0"
            src={favicon}
            alt="Logo Icon"
          />
        ) : (
          <motion.img
            key="full-logo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.4 }}
            className={`w-full ${maxWidthClass} md:ps-0`}
            src={logoSrc}
            alt="Full Logo"
          />
        )}
      </div>

      <div className="absolute flex h-full w-full items-center justify-between gap-4 px-2 md:hidden">
        {/* Sidebar Button */}
        <button onClick={handleToggleSidebar}>
          <IoMenu size={29} className="text-white" />
        </button>

        {/* User Info */}
        <HeaderInfo />
      </div>
    </div>
  );
}

export default Logo;
